// Native smooth drag-to-scroll
// Disables Dawn's slider snap behavior for smoother dragging
(function() {
  var containers = [];

  function setup(el) {
    if (el.dataset.vDrag) return;
    el.dataset.vDrag = '1';

    // Remove Dawn's scroll-snap which causes the lag
    el.style.scrollSnapType = 'none';
    el.style.cursor = 'grab';
    el.style.userSelect = 'none';
    el.style.scrollBehavior = 'auto';

    var state = { down: false, startX: 0, sl: 0, moved: false };

    el.addEventListener('mousedown', function(e) {
      if (e.button !== 0) return;
      state.down = true;
      state.moved = false;
      state.startX = e.clientX;
      state.sl = el.scrollLeft;
      el.style.cursor = 'grabbing';
      el.style.scrollBehavior = 'auto';
      e.preventDefault();
    });

    window.addEventListener('mousemove', function(e) {
      if (!state.down) return;
      var dx = e.clientX - state.startX;
      if (Math.abs(dx) > 5) state.moved = true;
      el.scrollLeft = state.sl - dx;
    });

    window.addEventListener('mouseup', function() {
      if (!state.down) return;
      state.down = false;
      el.style.cursor = 'grab';
    });

    // Block clicks after drag
    el.addEventListener('click', function(e) {
      if (state.moved) {
        e.preventDefault();
        e.stopPropagation();
        state.moved = false;
      }
    }, true);

    containers.push(el);
  }

  function init() {
    // Collection lists
    document.querySelectorAll('.collection-list-wrapper .grid, .collection-list-wrapper .slider').forEach(setup);

    // Featured collection sliders
    document.querySelectorAll('.slider.slider--desktop, .slider.slider--tablet').forEach(function(el) {
      if (el.closest('.announcement-bar-slider')) return;
      setup(el);
    });

    // Product recommendation grids
    document.querySelectorAll('.related-products .grid').forEach(setup);

    // Collection tabs product grids
    document.querySelectorAll('.collection-tabs__panel .grid').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function() {
    setTimeout(init, 300);
  });
})();
